export enum AuthView {
  SignIn = 'sign-in',
  Register = 'register',
}
